import { Outlet, useNavigate } from "react-router-dom";
import { MobileSidebar } from "@/components/mobile-sidebar";
import { useAuth } from "@/components/auth-provider";
import { useEffect } from "react";

export default function LandlordLayout() {
  const { status, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if not authenticated
  useEffect(() => {
    if (status === "unauthenticated") {
      navigate("/auth/signin");
    }
  }, [status, navigate]);

  // Redirect if not a landlord (but allow admin/super-admin)
  // Note: user.role comes from Firebase Custom Claims (secure, server-side only)
  useEffect(() => {
    if (status === "authenticated" && user) {
      console.log("Landlord layout - user:", user);
      console.log(
        "Landlord layout - user role (from custom claims):",
        user.role
      );

      const userRole = user.role;

      // Allow landlords, admins, and super-admins
      if (
        userRole !== "landlord" &&
        userRole !== "admin" &&
        userRole !== "super-admin"
      ) {
        console.log("User role not allowed for landlord portal:", userRole);
        if (userRole === "tenant") {
          console.log("Redirecting tenant to tenant portal");
          navigate("/tenant", { replace: true });
        } else {
          console.log("No appropriate role found, redirecting to home");
          navigate("/", { replace: true });
        }
      } else {
        console.log("Access granted to landlord portal for role:", userRole);
      }
    }
  }, [status, user, navigate]);

  // Main content with sidebar
  return (
    <MobileSidebar>
      <Outlet />
    </MobileSidebar>
  );
}
